/**
 * Home / collection composers are drafts, not a live thread. They must never
 * inherit Stop / spinning-send from some other conversation's isInferencing.
 */
export function isDraftComposerConversationId(conversationId) {
  if (conversationId == null || conversationId === '') return true;
  const id = String(conversationId);
  return id === 'new' || id.startsWith('new-');
}

/**
 * Stop is only a real action when this composer can cancel. A draft composer
 * (New Chat) has no onCancel — treating it as cancel leaves a spinning send
 * that swallows the next prompt.
 */
export function getComposerPerformableAction({
  hasPendingMessage = false,
  isInferencing = false,
  canSendWhileLive = false,
  canCancel = false,
} = {}) {
  if ((hasPendingMessage || isInferencing) && !canSendWhileLive && canCancel) {
    return 'cancel';
  }
  return 'send';
}

/**
 * Decide which controls fill the composer's right-side action slot.
 *
 * Dictation stays available when files are attached so users can describe a
 * screenshot or image by voice without first typing. Voice mode is a live
 * conversation that does not consume composer attachments, so it only appears
 * on a fully empty composer. Send appears whenever there is something to
 * submit (text, inline params, or files).
 */
export function getComposerActionControls({
  isInferencing = false,
  hideTextInput = false,
  hasAllRequiredFiles = true,
  value = '',
  hasInlineParamValue = false,
  filesLength = 0,
} = {}) {
  if (isInferencing) {
    return { showDictate: false, showVoice: false, showSend: true };
  }

  if (hideTextInput) {
    return {
      showDictate: false,
      showVoice: false,
      showSend: Boolean(hasAllRequiredFiles),
    };
  }

  const hasText = Boolean(value?.trim()) || Boolean(hasInlineParamValue);
  const hasFiles = filesLength > 0;

  return {
    showDictate: !hasText,
    showVoice: !hasText && !hasFiles,
    showSend: hasText || hasFiles,
  };
}
